/* eslint-disable import/prefer-default-export */
import { capitalize } from './helpers';

export const getResourceType = () => {
  const showWrapper = document.querySelector('[data-controller*="resource-show-main"]');
  const resourceType = showWrapper.dataset.resourceType === 'editorial' ? 'free' : showWrapper.dataset.resourceType;

  return capitalize(resourceType);
};
/* eslint-enable import/prefer-default-export */
